import React from "react";
import "../assets/css/GurukulOffers.css";
import offerImg from "../assets/home-page-imgs/tech.png"; 

const offers = [
    {
        title: "Proven Business Model",
        desc: "A tested, scalable model designed for long-term real estate success."
    },
    {
        title: "Expert Training & Certification",
        desc: "Structured programs led by industry professionals and mentors."
    },
    {
        title: "Branded Digital Tools",
        desc: "CRM, lead systems, sales scripts & marketing assets."
    },
    {
        title: "Marketing & Business Support",
        desc: "National & regional campaigns to boost visibility and growth."
    },
    {
        title: "Recognized Brand Backing",
        desc: "Leverage Samriddhi Group’s credibility and trust."
    }
];

const GurukulOffers = () => {
    return (
        <section className="offers-container">
            <h2 className="offers-title">
                Real Estate Gurukul <span>Offers</span>
            </h2>

            <div className="offers-wrapper">
                {/* Left Image */}
                <div className="offers-image">
                    <img src={offerImg} alt="Samriddhi Gurukul Platform" />
                </div>

                {/* Middle Gradient Rail */}
                <div className="offers-rail">
                    {offers.map((_, i) => (
                        <div key={i} className="offers-rail-icon" />
                    ))}
                </div>

                {/* Right Content */}
                <div className="offers-content">
                    {offers.map((item, i) => (
                        <div className="offers-item" key={i}>
                            <h4>{item.title}</h4>
                            <p>{item.desc}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default GurukulOffers;
